import { dispatch, getState } from '../../..';
import PumpingStationMotorSizeHelper, { IPumpingStationMotorSize } from '../../../../@types/model/masterData/pumpingStation/motorSize';
import GeneralFunctions from '../../../general/functions';
import MasterDataPumpingStationMotorSizeActions from './actions';

export default class MasterDataPumpingStationMotorSizeFunctions {
    private static listener : undefined | (() => void);


    public static readonly load = async () => {
        if (MasterDataPumpingStationMotorSizeFunctions.listener) return;
        
        dispatch(MasterDataPumpingStationMotorSizeActions.setLoading(true));
        dispatch(MasterDataPumpingStationMotorSizeActions.set([]));

        try {
            MasterDataPumpingStationMotorSizeFunctions.listener = PumpingStationMotorSizeHelper
                .collection()
                .onSnapshot((snapshot : firebase.firestore.QuerySnapshot<IPumpingStationMotorSize>) => {
                    const state = getState().masterData.pumpingStation.motorSize;

                    const list = state.motorSizes.slice();
                
                    const session = getState().auth.session;
                    if (!session) return;

                    // "added" | "removed" | "modified"
                    snapshot.docChanges().forEach((f) => {
                        const item = f.doc.data();
                        const index = list.findIndex(n => n.id === item.id);


                        switch (f.type) {
                            case 'added':
                                list.push(item);
                                break;
                            case 'modified':
                                list.splice(index, 1, item);
                                break;
                            case 'removed':
                                list.splice(index, 1);
                                break;
                        }
                    });

                    dispatch(MasterDataPumpingStationMotorSizeActions.set(list));
                    dispatch(MasterDataPumpingStationMotorSizeActions.setLoading(false));
                }, (ex) => {
                    GeneralFunctions.generalShowError(ex, 'Error loading pumps.');
                    dispatch(MasterDataPumpingStationMotorSizeActions.setLoading(false));
                }, () => {
                    dispatch(MasterDataPumpingStationMotorSizeActions.setLoading(false));
                    MasterDataPumpingStationMotorSizeFunctions.listener = undefined;
                });

        } catch (ex) {
            GeneralFunctions.generalShowError(ex, 'Error loading pumps.');
            dispatch(MasterDataPumpingStationMotorSizeActions.setLoading(false));
        }
    };
}